<div class="container-fluid p-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">


        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <form class="proposal-form-container mb-2" [formGroup]="sparkForm">
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
      <div (click)="toggleSection('basicInfo')"
        class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold  flex items-center">
          <span class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
            <i class="pi pi-building"></i>
          </span>
          Basic Information
        </h3>
        <i class="pi transition-transform duration-200"
          [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
      </div>
      <div *ngIf="expandedSections['basicInfo']" class="p-6 space-y-6 border-t border-slate-100 animate-fade-in">

        <div class="grid grid-cols-12 gap-6 items-center">

          <!-- Challenge Title -->
          <label class="col-span-3 font-medium text-slate-700 mb-0 flex items-center">
            Challenge Title
            <span class="text-red-500 ml-1">*</span>
          </label>
          <div class="col-span-9">
            <input pInputText id="proposal_name" type="text"
              class="w-full px-2 py-2 border-2 rounded border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              formControlName="challenge_title" placeholder="Enter Proposal Name" autocomplete="off" />
          </div>



          <!-- Project Development Budget -->
          <label class="col-span-3 font-medium text-slate-700 mb-0 flex items-center">
            Project Development Budget (in INR)
            <span class="text-red-500 ml-1">*</span>
          </label>
          <div class="col-span-3">
            <input pInputText id="project" type="number" min="0.01" step="0.01"
              class="w-full px-2 py-2 border-2 rounded border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              formControlName="development_budget" placeholder="Enter budget amount" autocomplete="off" />
            <div class="text-sm text-red-600 mt-1"
              *ngIf="sparkForm.get('development_budget')?.touched && sparkForm.get('development_budget')?.errors">
              <div *ngIf="sparkForm.get('development_budget')?.errors?.['required']">
                Project Development Budget is required.
              </div>
              <div *ngIf="sparkForm.get('development_budget')?.errors?.['pattern']">
                Only numeric values (max two decimals) are allowed.
              </div>
              <div *ngIf="sparkForm.get('development_budget')?.errors?.['min']">
                Budget must be greater than 0.
              </div>
            </div>
          </div>

          <!-- Category -->
          <label class="col-span-2 font-medium text-slate-700 mb-0 flex items-center">
            Category
            <span class="text-red-500 ml-1">*</span>
          </label>
          <div class="col-span-4">
            <input pInputText id="category" type="text"
              class="w-full px-2 py-2 border-2 rounded border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              formControlName="category" placeholder="Enter Category Name" autocomplete="off" />
          </div>
        </div>

        <!-- Validity of Contract (Dates) -->
        <!-- <div class="grid grid-cols-12 gap-6 items-center">
                    <label class="col-span-3 font-medium text-slate-700 mb-0 flex items-center">
                        Project Start Date
                        <span class="text-red-500 ml-1">*</span>
                    </label>
                    <div class="col-span-3">
                        <input
                            pInputText
                            id="projectStartDate"
                            type="date"
                            class="w-full px-2 py-2 border-2 rounded border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            formControlName="start_date"
                            placeholder="Enter project start date"
                            autocomplete="off"
                        />
                    </div>

                    <label class="col-span-2 font-medium text-slate-700 mb-0 flex items-center justify-start">
                        Project End Date
                        <span class="text-red-500 ml-1">*</span>
                    </label>
                    <div class="col-span-4">
                        <input
                            pInputText
                            id="projectEndDate"
                            type="date"
                            class="w-full px-2 py-2 border-2 rounded border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            formControlName="end_date"
                            placeholder="Enter project end date"
                            autocomplete="off"
                        />
                    </div>
                    <label class="col-span-3 font-medium text-slate-700 mb-0 flex items-center">
                      Upload WBS
                      <span class="text-red-500 ml-1">*</span>
                  </label>
                  <div class="col-span-9">
                    <input pInputText id="file_name" type="file" accept=".xlsx" (change)="onFileUpload($event)"
                    class="w-full px-4 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Enter File Name" autocomplete="off" />
                  </div>
                </div> -->

      </div>
    </div>
    <!-- <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="toggleSection('uploads')"
                class="flex items-center justify-between p-3 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold flex items-center gap-2">
                    <span
                        class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-upload"></i>
                    </span>
                    Upload Spark Agreement & Supporting Documents
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['uploads']" class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">
                <app-upload-document [isEditable]="stepDetails.can_edit" >      </app-upload-document>
            </div>
          </div> -->
  </form>

  <!-- ================= VENDOR TABS + EDIT SAVE ================= -->
  <div class="bg-white border rounded-lg shadow p-4">

    <!-- ================= WBS TABLE ================= -->
    <div class="bg-white border rounded-lg shadow p-4">

      <!-- ================= TABS ================= -->
      <div class="flex items-center justify-between border-b pb-3">

  <!-- LEFT: TABS -->
  <div class="flex gap-3 overflow-auto">
    <div *ngFor="let tab of vendorTabs; let i = index"
      (click)="changeVendorTab(i)"
      class="flex items-center gap-2 px-5 py-2 rounded-full border cursor-pointer whitespace-nowrap transition-all duration-300"
      [ngClass]="activeVendorIndex === i
        ? 'bg-blue-800 text-white border-blue-800 shadow-md'
        : 'bg-gray-100 text-slate-600 border-gray-300 hover:bg-gray-200'">

      <div class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
        [ngClass]="activeVendorIndex === i
          ? 'bg-white text-blue-800'
          : 'bg-blue-100 text-blue-800'">
        {{ tab.name?.charAt(0) }}
      </div>

      <span class="font-semibold text-sm">
        {{ tab.name }}
      </span>

    </div>
  </div>

  <!-- RIGHT: BUTTONS -->
  

</div>


   <div class="flex items-center justify-between border-b pb-3 mt-4">

  <!-- LEFT: TABS -->
  <div class="flex gap-3 overflow-auto">
    <!-- tabs -->
  </div>

  <!-- RIGHT: BUTTONS -->
  <div class="flex gap-3">

    <button *ngIf="!isEditMode"
      (click)="enableEdit()"
      class="bg-yellow-500 text-white px-4 py-2 rounded-md text-sm">
      Edit
    </button>

    <button *ngIf="isEditMode"
      (click)="saveVendorData()"
      class="bg-green-600 text-white px-4 py-2 rounded-md text-sm">
      Save
    </button>

  </div>

</div>

      <!-- ================= GRANT FORM ================= -->
      <form [formGroup]="sparkForms">

        <div class="bg-gray-50 border rounded-lg p-4 mt-4">

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

            <!-- FILE -->
            <div>
              <label class="text-sm font-semibold">Spark Grant Agreement</label>

              <input type="file" (change)="onGrantFileChange($event)"  formControlName="sign_document" class="w-full border rounded-md p-2 text-sm" />

              <a *ngIf="vendorTabs[activeVendorIndex]?.grant?.sign_document"
                [href]="vendorTabs[activeVendorIndex].grant.sign_document?.startsWith('http') 
  ? vendorTabs[activeVendorIndex].grant.sign_document 
  : baseUrl + vendorTabs[activeVendorIndex].grant.sign_document" target="_blank"
                class="text-blue-600 underline text-xs">

                {{ getFileName(vendorTabs[activeVendorIndex]?.grant?.sign_document) }}

              </a>
            </div>

            <!-- Spark -->
            <div>
              <label class="text-sm font-semibold">Spark Grant Approved (INR)</label>
              <input type="number" step="0.01" formControlName="spark_grant_approve"
                class="w-full border rounded-md p-2 text-sm" />
            </div>

            <!-- Matching -->
            <div>
              <label class="text-sm font-semibold">Matching Contribution (INR)</label>
              <input type="number" step="0.01" formControlName="matching_contribution"
                class="w-full border rounded-md p-2 text-sm" />
            </div>

          </div>

          <!-- Dates -->
          <div class="grid grid-cols-2 gap-4 mt-4">

            <div>
              <label class="text-sm font-semibold">Start Date</label>
              <input type="date" formControlName="start_date" class="w-full border rounded-md p-2 text-sm" />
            </div>

            <div>
              <label class="text-sm font-semibold">End Date</label>
              <input type="date" formControlName="end_date" class="w-full border rounded-md p-2 text-sm" />
            </div>

          </div>

        </div>

      </form>
        <!-- RIGHT BUTTONS -->
 


      <!-- ================= TABLE ================= -->
       <h3 class="text-lg font-semibold mt-4 mb-2">
         Work Breakdown Structure
       </h3>
      <div class="overflow-auto mt-4">

        <table class="w-full border text-sm">

          <thead class="bg-slate-100">
            <tr>
              <th *ngFor="let col of tableColumn" class="border px-3 py-2 text-left">
                {{ col }}
              </th>
            </tr>
          </thead>

          <tbody>

            <tr *ngFor="let row of vendorTabs[activeVendorIndex]?.data" class="hover:bg-blue-50">

              <td *ngFor="let col of tableColumn" class="border px-3 py-2">

                <!-- VIEW -->
                <ng-container *ngIf="!isEditMode">
                  {{ row[col] || '-' }}
                </ng-container>

                <!-- EDIT -->
                <ng-container *ngIf="isEditMode">

                  <!-- Calendar for Date -->
                  <input *ngIf="col === 'Start Date' || col === 'End Date'" type="date" [(ngModel)]="row[col]"
                    [ngModelOptions]="{standalone:true}" class="w-full border rounded p-1 text-xs" />

                  <!-- Textarea -->
                  <textarea *ngIf="col !== 'Start Date' && col !== 'End Date'" [(ngModel)]="row[col]"
                    [ngModelOptions]="{standalone:true}" rows="1" class="w-full border rounded p-1 text-xs">
              </textarea>

                </ng-container>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>


  </div>